import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale';
Vue.use(VueI18n);
// 引入自定义的各个语言配置文件
import en_ID from './config/id';
import en_US from './config/en';
import zh_CN from './config/zh';

//element-ui自带多语言配置
import idLocale from 'element-ui/lib/locale/lang/id';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

const messages = {
    en_US: {
        ...en_US,
        ...enLocale
    },
    en_ID: {
        ...en_ID,
        ...idLocale
    },
    zh_CN: {
        ...zh_CN,
        ...zhLocale
    },
}
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
    // 设置默认语言
    locale: localStorage.getItem('language') || 'en_US', // 语言标识,页面对应显示相同的语言
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: messages,
    globalInjection: true, // 全局注入
    fallbackLocale: 'en_US', // 指定的locale没有找到对应的资源或当前语种不存在时，默认设置当前语种为中文
})
// 非 vue 文件中使用这个方法
const translate = (localeKey) => {
    const locale = localStorage.getItem("language") || "en_US"
    const hasKey = i18n.te(localeKey, locale)  // 使用i18n的 te 方法来检查是否能够匹配到对应键值
    const translatedStr = i18n.t(localeKey) // 找到插件自带的或者我们自定义添加的语言内容

    if (hasKey) {
        return translatedStr
    }
    return localeKey
}

locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
// 暴露i18n
export {
    i18n,
    translate
};